import { useEffect, useRef } from 'react';

// Simple SSE hook that accepts a URL and a callback to invoke on 'notification' events
export const useNotificationsSSE = (onMessage: (data: any) => void) => {
  const esRef = useRef<EventSource | null>(null);

  useEffect(() => {
    const url = import.meta.env.VITE_NOTIFICATIONS_SSE_URL as string | undefined;
    if (!url) return;

    try {
      const es = new EventSource(url, { withCredentials: true });
      es.onopen = () => console.log('SSE connected:', url);
      es.onerror = (err) => {
        console.warn('SSE error', err);
      };
      es.addEventListener('notification', (ev: any) => {
        try {
          const payload = JSON.parse(ev.data);
          onMessage(payload);
        } catch (e) {
          console.error('Failed to parse SSE notification', e);
        }
      });
      esRef.current = es;
    } catch (e) {
      console.warn('Failed to initialize SSE', e);
    }

    return () => {
      if (esRef.current) {
        esRef.current.close();
        esRef.current = null;
      }
    };
  }, [onMessage]);
};

